import {AxiosPromise} from 'axios'
import Client from 'core/api/client'

/**
 * Expected payload for /study/coordinator/auth/login endpoint
 */
export interface ILogin {
  email: string
  password: string
}

export function login(data: ILogin): AxiosPromise {
  return Client.post('/study/coordinator/auth/login', data)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/login.ts